/**
 * Printes the value in the specified format.
 * `{unit}` is the default one where {unit} is
 * replaced with the actual value.
 *
 * @param {Any} value [description]
 * @param {String} format [description]
 * @return {String} [description]
 */
const formatLabel = (value, format) => {
  const defaultFormat = '{unit}'
  if (format === defaultFormat) {
    return value
  }

  return format.replace(defaultFormat, value)
}

module.exports = formatLabel



// WEBPACK FOOTER //
// ./front/apps/public/shared/components/chart/helpers/format_label.js